import { Controller } from "@hotwired/stimulus"

// Inline dodawanie pola własnego z formatki rekordu: popover (etykieta + typ) -> POST do
// /automation/custom_fields.json -> dołożenie gotowego inputu (markup z serwera, ten sam
// partial co pętla pól) PRZED tym blokiem - bez przeładowania, dane formularza zostają.
export default class extends Controller {
  static targets = ["panel", "label", "kind", "keyPreview", "msg"]
  static values = { url: String, subjectType: String, scope: String, csrf: String }

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden
    if (!this.panelTarget.hidden) this.labelTarget.focus()
  }

  labelChanged() {
    this.keyPreviewTarget.textContent = this.slugify(this.labelTarget.value)
  }

  // Enter zapisuje pole (bez submitu całego formularza rekordu)
  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    }
  }

  async save() {
    const label = this.labelTarget.value.trim()
    if (!label) { this.labelTarget.focus(); return }
    this.msgTarget.textContent = ""

    try {
      const res = await fetch(`${this.urlValue}.json`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.csrfValue, Accept: "application/json" },
        body: JSON.stringify({
          custom_field: { label, subject_type: this.subjectTypeValue, kind: this.kindTarget.value },
        }),
      })
      if (!res.ok) {
        const errors = await res.json()
        this.msgTarget.textContent = Object.entries(errors).map(([k, v]) => `${k}: ${[v].flat().join(", ")}`).join("; ")
        return
      }

      const field = await res.json()
      // gotowy markup inputu z serwera (ten sam partial co pętla pól) - spójny wygląd i nazwy
      const inputRes = await fetch(`${this.urlValue}/${field.id}/input?scope=${encodeURIComponent(this.scopeValue)}`)
      if (inputRes.ok) {
        this.element.insertAdjacentHTML("beforebegin", await inputRes.text())
        const added = this.element.previousElementSibling.querySelector("input, select, textarea")
        if (added) added.focus()
      }

      this.labelTarget.value = ""
      this.keyPreviewTarget.textContent = ""
      this.panelTarget.hidden = true
    } catch {
      this.msgTarget.textContent = "error"
    }
  }

  // Podgląd klucza-sluga (transliteracja polskich znaków); serwer liczy klucz niezależnie
  slugify(text) {
    const map = { ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z" }
    return text
      .toLowerCase()
      .replace(/[ąćęłńóśźż]/g, (ch) => map[ch])
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .replace(/^[0-9]+/, "")
      .slice(0, 50)
  }
}
